import { gql } from "@apollo/client"

const QUERY_MAINLANG = gql`
    query baseData {
        baseData {
            mainLang
            tariffComparisonMode
        }
    }
`

const QUERY = gql`
    query getPrices(
        $searchword: String
        $perpage: Int!
        $page: Int!
        $sortDirection: SortMode
        $propertyName: String
        $department: [String]
        $productGroup: [String]
        $productCat: [String]
        $productSubCat: [String]
        $producer: [String]
        $mappingState: MAPPING_STATE
        $buttoncatsearch: Boolean
        $sortShopId: Long
        $pricetableShopId: Long
        $presetId: Long
        $currencyLang: String
        $sortLang: String
        $sortRanking: Boolean
        $discontinuedItems: Boolean
        $sortMinPrice: Float!
        $sortMaxPrice: Float!
        $genericFilter: Boolean
        $amazonBuyboxFilter: String
        $amazonBuyboxShopIds: [Long]
    ) {
        shops(onlyActive: true) {
            name
            shortName
            id
            lang
            domain
        }
        settings {
            presets {
                label: name
                value: id
            }
        }
        pricetable(
            search: $searchword
            perPage: $perpage
            page: $page
            sorting: {
                mode: $sortDirection
                shopId: $sortShopId
                propertyName: $propertyName
                currencyLang: $currencyLang
                lang: $sortLang
                ranking: $sortRanking
                minPrice: $sortMinPrice
                maxPrice: $sortMaxPrice
                genericFilter: $genericFilter
                amazonBuyboxFilter: $amazonBuyboxFilter
                amazonBuyboxShopIds: $amazonBuyboxShopIds
            }
            department: $department
            productGroup: $productGroup
            productCat: $productCat
            productSubCat: $productSubCat
            producer: $producer
            mappingState: $mappingState
            buttoncatsearch: $buttoncatsearch
            shopId: $pricetableShopId
            presetId: $presetId
            discontinuedItems: $discontinuedItems
        ) {
            exportDate
            importFeedDate
            maxId
            totalProducts
            currencyIsoCode
            preset {
                name
                id
                columns {
                    order
                    propertyName
                    frontendv2format
                }
                shops {
                    order
                    shop {
                        name
                        shortName
                        id
                        lang
                        domain
                    }
                }
            }
            productPrices {
                id
                ean
                productnr: productNr
                ranking
                stockCount
                department
                productGroup
                productCat
                productName
                producer
                pricesV2 {
                    value
                    symbol
                    lang
                    stockLight
                }
                secondPricesV2 {
                    value
                    symbol
                    lang
                }
                imageUrl
                urls
                extartnr
                avgPrice
                avgTotalPrice
                avgCountDealers
                minPrice
                minTotalPrice
                maxPrice
                maxTotalPrice
                checked
                appointed
                discontinuedItem: discontinuedItems
                packageunit
                priceEk
                minPriceMerchantName
                minTotalPriceMerchantName
                maxPriceMerchantName
                maxTotalPriceMerchantName
                genericColumns
                mappingEditinfo
                foreignShopsProductInformations {
                    shopname
                    shopId
                    productnr
                    productName
                    producer
                    price
                    priceByTotalPriceProvider
                    totalPrice
                    totalPriceByTotalPriceProvider
                    secondPrice
                    secondTotalPrice
                    stock
                    lang
                    crawlDate
                    currency
                    currencySymbol
                    secondCurrencySymbol
                    url
                    imageUrl
                    additionalData
                    cheapestMerchantName
                    cheapestMerchantNameTotalPrice
                    parsingFlag
                    priceDifference
                    totalPriceDifference
                    productInfoFrontend
                    merchantPrices {
                        name
                        price
                        totalPrice
                        deliveryPrice
                        stock
                        url
                        tarif {
                            displayPrice
                            tarifInfoMap
                        }
                    }
                    matchingType
                    isCustomerSelf
                }
            }
        }
    }
`

const PRICETABLE_EXPORT_QUERY = gql`
    mutation startPricetableExport(
        $searchword: String
        $sortDirection: SortMode
        $propertyName: String
        $department: [String]
        $productGroup: [String]
        $productCat: [String]
        $productSubCat: [String]
        $producer: [String]
        $mappingState: MAPPING_STATE
        $buttoncatsearch: Boolean
        $sortShopId: Long
        $pricetableShopId: Long
        $presetId: Long
        $currencyLang: String
        $sortLang: String
        $sortRanking: Boolean
        $sortMinPrice: Float!
        $sortMaxPrice: Float!
        $genericFilter: Boolean
        $amazonBuyboxFilter: String
        $amazonBuyboxShopIds: [Long]
    ) {
        startPricetableExport(
            search: $searchword
            sorting: {
                mode: $sortDirection
                shopId: $sortShopId
                propertyName: $propertyName
                currencyLang: $currencyLang
                lang: $sortLang
                ranking: $sortRanking
                minPrice: $sortMinPrice
                maxPrice: $sortMaxPrice
                genericFilter: $genericFilter
                amazonBuyboxFilter: $amazonBuyboxFilter
                amazonBuyboxShopIds: $amazonBuyboxShopIds
            }
            department: $department
            productGroup: $productGroup
            productCat: $productCat
            productSubCat: $productSubCat
            producer: $producer
            mappingState: $mappingState
            buttoncatsearch: $buttoncatsearch
            shopId: $pricetableShopId
            presetId: $presetId
        ) {
            responseCode
            responseMessage
            downloadUrl
        }
    }
`

export { QUERY_MAINLANG, QUERY, PRICETABLE_EXPORT_QUERY }
